module.exports = __webpack_public_path__ + "img/camera-fp.35d3b602.svg";